import {
  DEFAULT_CURRENCY_CODE,
  inject,
  LOCALE_ID,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { CurrencyCode } from '../../models/currency/currency-code.enum';
import { LocaleId } from '../../models/locale/locale-id.enum';
import { formatCurrency } from '../../utils/currency/currency.utils';

@Pipe({
  name: 'currencyFormat',
  standalone: true,
})
export class CurrencyFormatPipe implements PipeTransform {
  private readonly currencyCode = inject<CurrencyCode>(DEFAULT_CURRENCY_CODE);
  private readonly localeId = inject<LocaleId>(LOCALE_ID);

  transform(
    value: number | string | undefined | null,
    digitsInfo = '1.2-2',
  ): string {
    return formatCurrency(value, this.currencyCode, this.localeId, digitsInfo);
  }
}
